import { render } from "./LabEquipmentDetailPage.vue?vue&type=template&id=51109492"
import script from "./LabEquipmentDetailPage.vue?vue&type=script&lang=js"
export * from "./LabEquipmentDetailPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__